import { HttpClient, provideHttpClient } from "@angular/common/http";
import { APP_INITIALIZER, NgModule } from "@angular/core";

import { LocalizationService } from "../services/localization.service";

import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";

export function initLocal(service: LocalizationService): () => void {
  return () => service.init();
}

@NgModule({
  imports: [
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpClient) => new TranslateHttpLoader(http, "i18n/", ".json"),
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    provideHttpClient(),
    {
      provide: APP_INITIALIZER,
      useFactory: initLocal,
      deps: [LocalizationService],
      multi: true,
    },
  ],
})
export class LocalizationModule {
  static forRoot() {
    return {
      ngModule: LocalizationModule,
    };
  }
}
